import { useTranslation } from "../../i18n/hooks/useTranslation";
import LanguageSelectorStyled from "./LanguageSelectorStyled";

const LanguageSelector = (): JSX.Element => {
  const { changeLanguage, currentLanguage, availableLanguages } =
    useTranslation();

  return (
    <LanguageSelectorStyled>
      {availableLanguages.map((lang) => (
        <button
          key={lang}
          onClick={() => changeLanguage(lang)}
          className={currentLanguage === lang ? "active" : ""}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </LanguageSelectorStyled>
  );
};

export default LanguageSelector;
